import { render, staticRenderFns } from "./CustomDashboard.vue?vue&type=template&id=58ee78b4&scoped=true&"
import script from "./CustomDashboard.vue?vue&type=script&lang=ts&"
export * from "./CustomDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ee78b4",
  null
  
)

export default component.exports